import { IAction } from '../../../authentiction/reducer';
import {
  IVisitorQuestionnaireState,
  VisitorQuestionnaireAnswer,
} from './index';
import produce from 'immer';

export const initialState: IVisitorQuestionnaireState = {
  questions: {
    byId: {},
    answeredIds: [],
    allIds: [],
  },
  sections: {
    byId: {},
    allIds: [],
  },
};

const QUESTIONNAIRE_INITIALIZED = 'QUESTIONNAIRE_INITIALIZED';
const QUESTION_ANSWERED = 'QUESTION_ANSWERED';

export const questionnaireInitialized = (
  value: IVisitorQuestionnaireState,
): IAction => ({
  type: QUESTIONNAIRE_INITIALIZED,
  payload: value,
});

export const questionAnswered = (
  questionId: number,
  answer: VisitorQuestionnaireAnswer,
): IAction => ({
  type: QUESTION_ANSWERED,
  payload: { questionId, answer },
});

export const visitorQuestionnaireReducer = (
  state: IVisitorQuestionnaireState,
  action: IAction,
): IVisitorQuestionnaireState => {
  const { type, payload } = action;

  switch (type) {
    case QUESTIONNAIRE_INITIALIZED:
      return payload;

    case QUESTION_ANSWERED:
      const { questionId, answer } = payload;

      return produce(state, (draft) => {
        draft.questions.byId[questionId].answer = answer;
        draft.questions.answeredIds.push(questionId);
      });

    default:
      throw new Error();
  }
};
